import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW2300Component } from './kymw2300.component';
import { GetPageInfoService } from './api-services/get-page-info.service';
import { CheckProgressHistoryService } from './api-services/check-progress-history.service';
import { ExecutePrintCompanyDataService } from './api-services/execute-print-company-data.service';
import { ExecutePrintCompanyDataThumbnailService } from './api-services/execute-print-company-data-thumbnail.service';
import { CatalogLockService } from '../../../commons/kymw00/api-services/catalog-lock.service';

/**
 * 特別指示書画面 モジュール設定クラス
 *
 * @export KYMW2300Module
 * @class KYMW2300Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW2300Component,
  ],
  providers: [
    GetPageInfoService,
    CheckProgressHistoryService,
    ExecutePrintCompanyDataService,
    ExecutePrintCompanyDataThumbnailService,
    CatalogLockService,
  ],
})
export class KYMW2300Module {
}
